import { render } from "./department.vue?vue&type=template&id=60b5074c&ts=true"
import script from "./department.vue?vue&type=script&lang=ts"
export * from "./department.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/vue3-admin/vue3-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__